import { listTickerData } from "../../api/s3";

export const getMenuItemsx = async (auth, tickerStorage) => {
  const list = await listTickerData(auth, tickerStorage);
  return list.map((item) => {
    return { display: item, value: item };
  });
};

export const getMenuItems = async (menukey, auth, tickerStorage, data) => {
  switch (menukey) {
    case "FairValue1":
    case "FairValue2":
      const uniqueTickers = Array.from(
        new Set(data.map((item) => item.Ticker).filter((fitem)=>fitem!=="0"&&!fitem.includes("%")))
      ).sort();
      return uniqueTickers.map((item) => {
        return { display: item, value: item };
      });
    case "FairValueStrike":
      const uniqueItems = Array.from(
        new Set(data.map((item) => item["Strike%Chg"]))
      ).sort((a, b) =>
        +a.replace("%", "") < +b.replace("%", "")
          ? 1
          : +a.replace("%", "") > +b.replace("%", "")
          ? -1
          : 0
      );
      return uniqueItems.map((item) => {
        return { display: item, value: item };
      });
    case "horizon":
      const horizonlist = Array.from(
        new Set(data.filter((item, i) => i > 0).map((item) => item.Column_68))
      ).sort((a, b) =>
        +a.value > +b.value ? 1 : +a.value < +b.value ? -1 : 0
      );
      return horizonlist.map((item) => {
        return { display: item, value: item };
      });

    case "spiderTicker":
      const spiderlist = Array.from(
        new Set(data.filter((item, i) => i > 0).map((item) => item.Column_2))
      ).sort();
      return spiderlist.map((item) => {
        return { display: item, value: item };
      });
    case "ticker":
      const tlist = await listTickerData(auth, tickerStorage, "ticker/");
      return tlist
        .filter((f) => {
          return !f.includes("/");
        })
        .map((item) => {
          return { display: item, value: item };
        });
    case "storedValueTicker":
      const svtlist = await listTickerData(auth, tickerStorage, "storedvalue/");
      return svtlist
        .filter((f) => {
          return !f.includes("/");
        })
        .map((item) => {
          return { display: item, value: item };
        });
    case "storedValueHorizon":
      return ["1", "10", "21", "63", "126", "252"].map((item) => {
        return { display: item, value: item };
      });

    default:
      return null;
  }
};
